import { Injectable } from '@angular/core';
import { NewYearAudioContextService } from './new-year-audio-context.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class NewYearSoundsLoaderService {
  private buffers: AudioBuffer[] = [];
  private context: AudioContext;

  constructor(private audioContextService: NewYearAudioContextService, private http: HttpClient) {
    this.context = this.audioContextService.context;
  }

  async loadSound(url: string): Promise<AudioBuffer> {
    try {
      const arrayBuffer = await this.http.get(url, { responseType: 'arraybuffer' }).toPromise();
      return await this.context.decodeAudioData(arrayBuffer);
    } catch (error) {
      console.error(`Error loading sound from ${url}:`, error);
      throw error;
    }
  }

  async loadSounds(urls: string[]): Promise<void> {
    const bufferPromises = urls.map((url) => this.loadSound(url));
    this.buffers = await Promise.all(bufferPromises);
  }

  getSound(index: number): AudioBuffer | undefined {
    return this.buffers[index];
  }
}
